import { Model, SafetyNearMissReport } from ".";

export default class SafetyNearMissReportType extends Model {
	get singularNoun() {
		return "near miss report type";
	}

	get mutations() {
		return {
			reports: SafetyNearMissReport
		};
	}

	resource() {
		return "safety/near-miss-report-types";
	}
}
